export default "__VITE_ASSET__ChgbibPD__"